import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, ArrowRight, MailCheck, KeyRound } from 'lucide-react';
import { api, errMsg } from '@/lib/api';
import { AuthLayout } from '@/pages/LoginPage';
import { PasswordInput } from '@/components/PasswordInput';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post('/auth/forgot-password', { email: email.trim() }); setSent(true); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Lupa kata sandi" subtitle="Masukkan email akun Anda. Kami akan mengirim tautan untuk membuat kata sandi baru." footer={<Link to="/login" className="font-medium text-primary hover:underline" data-testid="forgot-back-login">Kembali ke halaman masuk</Link>}>
      {sent ? (
        <div className="rounded-xl bg-emerald-50 p-5 text-sm text-emerald-900 flex gap-3" data-testid="forgot-sent"><MailCheck className="shrink-0" size={20} /><div><p className="font-medium">Periksa email Anda</p><p className="mt-1 text-emerald-800/80">Jika <strong>{email}</strong> terdaftar, tautan reset telah dikirim dan berlaku 1 jam. Cek juga folder spam.</p></div></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5"><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-11" data-testid="forgot-email-input" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 rounded-xl" data-testid="forgot-submit-button">{busy ? <Loader2 className="animate-spin" size={18} /> : <>Kirim tautan reset <ArrowRight size={16} className="ml-1" /></>}</Button>
        </form>
      )}
    </AuthLayout>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error('Konfirmasi kata sandi tidak cocok'); return; }
    setBusy(true);
    try { await api.post('/auth/reset-password', { token, password: form.password }); setDone(true); setTimeout(() => navigate('/login'), 2500); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Buat kata sandi baru" subtitle="Gunakan minimal 6 karakter. Setelah berhasil, masuk dengan kata sandi baru Anda." footer={<Link to="/login" className="font-medium text-primary hover:underline">Kembali ke halaman masuk</Link>}>
      {!token ? <p className="text-sm text-rose-700" data-testid="reset-no-token">Tautan tidak valid. Silakan minta tautan reset baru dari halaman <Link to="/forgot-password" className="underline">lupa kata sandi</Link>.</p> : done ? (
        <div className="rounded-xl bg-emerald-50 p-5 text-sm text-emerald-900 flex gap-3" data-testid="reset-done"><KeyRound className="shrink-0" size={20} /><div><p className="font-medium">Kata sandi berhasil diubah</p><p className="mt-1 text-emerald-800/80">Mengalihkan ke halaman masuk…</p></div></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-1.5"><Label htmlFor="password">Kata sandi baru</Label><PasswordInput id="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-xl h-11" testid="reset-password-input" /></div>
          <div className="space-y-1.5"><Label htmlFor="confirm">Ulangi kata sandi</Label><PasswordInput id="confirm" required minLength={6} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="rounded-xl h-11" testid="reset-confirm-input" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 rounded-xl" data-testid="reset-submit-button">{busy ? <Loader2 className="animate-spin" size={18} /> : 'Simpan kata sandi baru'}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
